import { render, staticRenderFns } from "./customKPI.vue?vue&type=template&id=4ac2138b&"
import script from "./customKPI.vue?vue&type=script&lang=js&"
export * from "./customKPI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports